// Mock data for consulting services website

export const services = [
  {
    id: 1,
    title: "Chief Revenue Officer (CRO) as a Service",
    description: "Strategic revenue leadership to scale your business predictably",
    details: [
      "Revenue strategy & planning",
      "Sales & marketing alignment",
      "Revenue operations setup",
      "Pricing & packaging strategy",
      "Customer lifecycle optimization",
      "Team structure & hiring guidance"
    ],
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Chief Sales Officer (CSO) as a Service",
    description: "Build and scale a high-performing sales organization",
    details: [
      "20+ years of scaling SaaS companies at various stages",
      "Transitioning bootstrapped companies from B2C to B2B",
      "Set up new business units",
      "Sales strategy & playbook development",
      "Sales process optimization",
      "Performance metrics & KPIs"
    ],
    icon: "Users"
  },
  {
    id: 3,
    title: "GTM Teams & Strategy",
    description: "Complete go-to-market execution for rapid growth",
    details: [
      "GTM strategy & execution",
      "Market positioning & messaging",
      "Channel strategy development",
      "Launch planning & execution",
      "Team coordination & alignment",
      "Performance tracking & optimization"
    ],
    icon: "Rocket"
  },
  {
    id: 4,
    title: "Product Marketing",
    description: "Position your product for maximum market impact",
    details: [
      "Product positioning & messaging",
      "Competitive analysis",
      "Customer research & insights",
      "Launch strategy & execution",
      "Sales collateral & enablement",
      "Market expansion planning"
    ],
    icon: "Target"
  },
  {
    id: 5,
    title: "Product Relevance & Roadmap",
    description: "Align product strategy with market needs and revenue goals",
    details: [
      "Product-market fit validation",
      "Roadmap prioritization",
      "Feature value assessment",
      "Customer feedback loops",
      "Competitive positioning",
      "Revenue impact analysis"
    ],
    icon: "Map"
  },
  {
    id: 6,
    title: "Product Roadmap to CTO/CPO",
    description: "Bridge the gap between product vision and technical execution",
    details: [
      "Strategic roadmap alignment",
      "Technical feasibility assessment",
      "Resource allocation planning",
      "Engineering-product collaboration",
      "Delivery timeline optimization",
      "Stakeholder communication"
    ],
    icon: "GitBranch"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Cost-Effective Leadership",
    description: "Save 60-70% compared to full-time senior hire",
    metric: "60-70% Savings",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Immediate Impact",
    description: "Start seeing results within weeks, not months",
    metric: "2-4 Week Onboarding",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Proven Experience",
    description: "Access to seasoned executives with multiple successful exits",
    metric: "15+ Years Average",
    icon: "Award"
  },
  {
    id: 4,
    title: "Flexible Engagement",
    description: "Scale up or down based on your needs and budget",
    metric: "100% Flexible",
    icon: "Maximize"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CEO, TechFlow AI",
    company: "Series A SaaS",
    quote: "Hiring a fractional CRO was the best decision we made. They built our entire sales function in 6 months - something that would have taken us 18 months to figure out on our own.",
    image: null
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "Founder, DataSync",
    company: "Seed Stage",
    quote: "We couldn't afford a full-time VP of Sales, but needed that level of expertise. The fractional CSO gave us enterprise-grade strategy at a startup-friendly price.",
    image: null
  },
  {
    id: 3,
    name: "Emily Watson",
    role: "Co-founder, CloudMetrics",
    company: "Pre-Seed",
    quote: "They helped us transition from B2C to B2B with a complete GTM strategy. Our revenue grew 3x in 8 months with their guidance.",
    image: null
  }
];

export const faqs = [
  {
    id: 1,
    question: "How is fractional leadership different from hiring a consultant?",
    answer: "Unlike traditional consultants who advise from the sidelines, fractional executives are embedded in your team. They own outcomes, make decisions, and execute alongside your team - just like a full-time executive, but at a fraction of the cost and time commitment."
  },
  {
    id: 2,
    question: "What time commitment can I expect?",
    answer: "Engagements typically range from 2-3 days per week to start. We tailor the commitment based on your stage, budget, and needs. As your business scales, we can adjust the engagement model accordingly."
  },
  {
    id: 3,
    question: "How quickly can we get started?",
    answer: "After our initial consultation, we can typically onboard within 1-2 weeks. We'll start with a strategic assessment, then move into execution mode with immediate impact on your revenue operations."
  },
  {
    id: 4,
    question: "What if I'm not ready for a full CRO or CSO?",
    answer: "Perfect! That's exactly what fractional leadership is for. You get senior-level strategic guidance while building your foundation. As you grow, we can scale the engagement or help you hire your full-time executive when the time is right."
  },
  {
    id: 5,
    question: "Do you work with companies outside of SaaS?",
    answer: "While we specialize in B2B SaaS and companies transitioning from B2C to B2B, we've successfully worked with various tech companies. Our expertise in sales operations, revenue strategy, and GTM execution translates across many business models."
  },
  {
    id: 6,
    question: "What's the typical ROI timeline?",
    answer: "Most clients see meaningful improvements within 60-90 days. This includes clearer revenue strategy, improved sales processes, and better team alignment. Long-term engagements typically show 2-4x ROI through increased revenue and avoided costly hiring mistakes."
  }
];

export const pricingComparison = {
  fullTime: {
    salary: 250000,
    benefits: 50000,
    equity: 100000,
    recruiting: 50000,
    total: 450000,
    timeToHire: "4-6 months",
    riskLevel: "High"
  },
  fractional: {
    cost: 120000,
    benefits: 0,
    equity: 0,
    recruiting: 0,
    total: 120000,
    timeToStart: "1-2 weeks",
    riskLevel: "Low",
    savings: 330000,
    savingsPercent: 73
  }
};

export const targetCompanies = [
  {
    stage: "Bootstrapped",
    description: "Building revenue foundations without breaking the bank"
  },
  {
    stage: "Pre-Seed",
    description: "Getting your sales motion right before scaling"
  },
  {
    stage: "Seed",
    description: "Scaling from $0 to $1M ARR efficiently"
  },
  {
    stage: "Series A",
    description: "Building predictable revenue engines"
  },
  {
    stage: "Series B",
    description: "Optimizing and scaling existing revenue operations"
  }
];

// Form submission mock
export const submitConsultationForm = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, message: "Thank you! We'll contact you within 24 hours." };
};

export const submitContactForm = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  return { success: true, message: "Message sent successfully!" };
};
